import DropdownOptions from "../../constants/DropdownOptions";
import { roles, subscriptionPlan } from "../../constants/UserAttributes";
import { globalApiHandler } from "../../services/services";
import { formatDate } from "../../utils/DateFormatter";
import { logout } from "../user/redux/action";
export const USER = {
  list: {
    success: "USERMANAGEMENT_LIST_SUCCESS",
    error: "USERMANAGEMENT_LIST_ERROR"
  },
  edit: {
    success: "USERMANAGEMENT_EDIT_SUCCESS",
    error: "USERMANAGEMENT_EDIT_ERROR"
  },
  update: {
    success: "USERMANAGEMENT_UPDATE_SUCCESS",
    error: "USERMANAGEMENT_UPDATED_ERROR"
  },
  disable: {
    success: "USERMANAGEMENT_DISABLE_SUCCESS",
    error: "USERMANAGEMENT_DISABLE_ERROR"
  },
  enable: {
    success: "USERMANAGEMENT_ENABLE_SUCCESS",
    error: "USERMANAGEMENT_ENABLE_ERROR"
  },
  delete: {
    success: "USERMANAGEMENT_DELETE_SUCCESS",
    error: "USERMANAGEMENT_DELETE_ERROR"
  },
  changePassword: {
    start: "USERMANAGEMENT_CHANGEPASSWORD_START",
    success: "USERMANAGEMENT_CHANGEPASSWORD_SUCCESS",
    error: "USERMANAGEMENT_CHANGEPASSWORD_ERROR"
  },
  resetState: {
    reset: "USERMANAGEMENT_RESET"
  },
  userType: {
    success: "USERMANAGEMENT_USERTYPE_SUCCESS"
  }
};

// returns list of users based on selected userType, mainFarm and subFarm
export const userListAction = userType => {
  let url = `/ntrac/admin/user`;
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    const selectedSubFarmId = getState().FarmManagementReducer.SubFarmId;
    if (userType || selectedMainFarm !== DropdownOptions.ALL_MAIN_FARM.id) {
      url = `${url}?`;
      if (userType && userType !== DropdownOptions.ALL_USERS[0].id) {
        url = `${url}role=${userType}`;
        if (selectedMainFarm !== DropdownOptions.ALL_MAIN_FARM.id) {
          url = `${url}&`;
        }
      }
      if (selectedMainFarm !== DropdownOptions.ALL_MAIN_FARM.id) {
        if (selectedMainFarm === selectedSubFarmId) {
          url = `${url}farmId=${selectedMainFarm}&subFarm=true`;
        } else {
          url = `${url}farmId=${selectedSubFarmId}`;
        }
      }
    }

    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = formatDate(item.updatedAt);
          item.name = `${item.firstName} ${item.lastName}`;
          item.displayedRoleName = roles[item.roleName];
          item.modifiable = item.roleName !== "SUPER_ADMIN";
          item.subscriptionPlan =
            subscriptionPlan[item.subscriptionId - 1] &&
            subscriptionPlan[item.subscriptionId - 1].name;
        });
        dispatch({ type: USER.list.success, data });
      })
      .catch(err => {
        dispatch({ type: USER.list.error });
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const userEditAction = data => {
  return dispatch => {
    dispatch({ type: USER.edit.success, data });
  };
};

export const userUpdateAction = userInfo => {
  let url = `/ntrac/user/${userInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", userInfo)
      .then(response => {
        dispatch({ type: USER.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const userDisableAction = id => {
  let url = `/ntrac/user/disable/${id}`;
  return dispatch => {
    globalApiHandler(url, "put", {})
      .then(response => {
        dispatch({ type: USER.disable.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const userEnableAction = id => {
  let url = `/ntrac/user/enable/${id}`;
  return dispatch => {
    globalApiHandler(url, "put", {})
      .then(response => {
        dispatch({ type: USER.enable.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const startChangePasswordAction = data => {
  return dispatch => {
    dispatch({ type: USER.changePassword.start, data });
  };
};

export const userChangePasswordAction = (userInfo,checkForSuperAdmin) => {
  let url = `/ntrac/admin/user`;
  return dispatch => {
    globalApiHandler(url, "put", userInfo)
      .then(response => {
        dispatch({ type: USER.changePassword.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
        if (checkForSuperAdmin) {
          localStorage.clear()
          logout()
          window.location.reload();  
      }})
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const stateResetAction = data => {
  return dispatch => {
    dispatch({ type: USER.resetState.reset });
  };
};

export const userTypeChangeAction = data => {
  return dispatch => {
    dispatch({ type: USER.userType.success, data });
  };
};

export const userDeleteAction = () => {};



// WEBPACK FOOTER //
// ./src/modules/userManagement/action.js